import * as React from 'react';

import {Card} from 'shells/card/card';
import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {PlugErrorState} from 'shells/illustrations/plug-error-state';

import styles from './special-states.module.css';

export function TimelineErrorState() {
    return (
        <div className={styles['outer-container']}>
            <Card hasBorder={true} fitHeight={true} fitContent={true}>
                <div className={styles['inner-container']}>
                    <EmptyStateSmall
                        title='Oh no! Something went wrong'
                        subtitle='There was an error retrieving these timeline entries'
                        icon={
                            <div style={{width: '100px'}}>
                                <PlugErrorState />
                            </div>
                        }
                    />
                </div>
            </Card>
        </div>
    );
}
